import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import TextBlock from '../../../components/TextBlock'
import ProjectDetails from '../../../components/ProjectDetails'
import ProjectHeader from '../../../components/ProjectHeader'
import SingleImage from '../../../components/SingleImage'
import Paragraph from '../../../components/Paragraph'
import AHref from '../../../components/AHref'

import featureImage from './p2p-preview_1600.jpg'
import featureImage2 from './p2p-feature-2.jpg'
import deck from './gumtree-paypal-deck-2.jpg'
import flows from './gumtree-paypal-ui-flows.png'
import userflows from './gumtree-paypal-userflow.jpg'
import phone from './gumtree-paypal-phone.jpg'
import phones from './gumtree-paypal-3-phones.jpg'
import macbook from './gumtree-paypal-macbook.jpg'

import './index.scss'

class GumtreePayPal extends Component {
  render () {
    const { children } = this.props

    return (
      <div>
        <ProjectHeader
          heading="Designing safer and easier ways to buy and sell"
          client="Gumtree Australia"
        />
        <SingleImage img={featureImage} margin />
        <ProjectDetails
          client="Gumtree Australia"
          role="User experience designer"
          duration="2 months in 2017"
          deliverables="User research, information architecture, wireframes, user flows"
          agency="Pollen"
          agencylink="https://www.pollen.com.au/"
        >
        <h2 className="h6">Background</h2>
        <p>Gumtree, Australia&rsquo;s marketplace, was interested in helping buyers and sellers connect in safer and more trusted ways.</p>
        <p>In Australia, PayPal is held in particularly high esteem for both for its safety and convenience. Gumtree asked Pollen to explore the idea of introducing PayPal as a cashless method of payment into the platform.</p>
        <p>I worked closely with the PayPal and Gumtree product teams to define a peer-to-peer payments system well suited to the local, face-to-face transactions of Gumtree.</p>
        </ProjectDetails>
        <TextBlock>
          <h2 className="h6">User testing</h2>
          <p>To first attain the focus of the opportunity, we worked closely with the PayPal and Gumtree product teams to conduct concept validation sessions with buyers and sellers from the Gumtree platform.</p>
          <p>At this stage, I was responsible for creating a set of user scenarios that demonstrated the ways in which Gumtree users might pay with PayPal. I prepared the script and testing plan for the moderator conducting each session.</p>
          <p>I worked alongside Pollen&rsquo;s senior art director, <AHref url="http://hugovann.com">Hugo Vann</AHref>, to develop a product vision and develop visuals that would be used during testing to demonstrate each scenario.</p>
        </TextBlock>
        <SingleImage img={deck} margin caption="I created 8 buyer and seller scenarios for user testing, working with Hugo Vann to develop visuals to match."/>
        <TextBlock>
          <h2 className="h6">Stay local</h2>
          <p>User testing revealed that we needed to stay true to the local marketplace experience of Gumtree. With all existing transactions taking place being face-to-face and cash-in-hand, a mobile, peer-to-peer payments model was a good fit.</p>
          <p>With this in mind, we designed a conversational UI that allowed sellers to accept payment from buyers through Gumtree&rsquo;s existing messaging system.</p>
        </TextBlock>
        <SingleImage img={userflows} margin caption="I worked with Adrian Wiggins to create a set of user flows outlining the logic that would underpin the experience." />
        <TextBlock>
          <p>Working with Adrian Wiggins, I developed an initial round of user flows, before creating high-fidelity wireframes that reflected Gumtree&rsquo;s existing UI.</p>
          <p>These high-fidelity flows were used to gain legal sign-off, however they also helped demonstrate how the experience would be integrated into the platform’s existing design system to Gumtree’s developers.</p>
        </TextBlock>
        <SingleImage img={flows} margin caption="I created high-fidelity wireframes / flows to demonstrate how the new experience would work within Gumtree's existing UI."/>
        <TextBlock>
          <h2 className="h6">A new UI</h2>
          <p>With the project occurring concurrently with the new rebrand, the new P2P payments system underwent a new design treatment from Pollen&rsquo;s Design Lead, <AHref url="http://www.visualicecream.com.au/">Brett Walsh</AHref>.</p>
        </TextBlock>
        <SingleImage img={phone} margin stacked />
        <SingleImage img={phones} margin stacked />
        <SingleImage img={macbook} margin />
        <TextBlock>
          <h2 className="h6">Launch</h2>
          <p>The Gumtree PayPal integration launched in both Canada and Australia in June 2017. The new system lets Gumtree users pay with PayPal across all platforms and devices - from iPhone to Android devices and the web.</p>
          <p>You can now <AHref url="https://www.gumtree.com.au">pay with PayPal on the Gumtree website</AHref>, <AHref url="https://play.google.com/store/apps/details?id=com.ebay.gumtree.au&hl=en">download the app for free on the App Store</AHref>, or <AHref url="https://www.paypal.com/au/webapps/mpp/gumtree">learn more about the Gumtree and PayPal partnership here</AHref>.</p>
        </TextBlock>
      </div>
    )
  }
}

GumtreePayPal.propTypes = {
  children: PropTypes.node,
}

export default GumtreePayPal



// WEBPACK FOOTER //
// ./src/pages/projects/gumtree-paypal/index.js